import { FindInStore } from '~domain/entities/FindInStore';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';

export class FindInStoreButtonLoadedUseCase {
    private skuId: string;
    private skuBaseId: number;
    private findInStore: FindInStore;

    constructor(skuId: string, skuBaseId?: number) {
        this.skuId = skuId;
        this.skuBaseId = skuBaseId || 0;
        this.findInStore = diContainer.get(serviceNames.findInStore);
    }

    public execute = () => {
        this.skuId && this.findInStore.update({ skuId: this.skuId });
        this.skuBaseId && this.findInStore.update({ skuBaseId: this.skuBaseId });
    };
}
